import { Option } from '../option'

export enum ConfirmDetailType {
  TEXT = 'TEXT',
  SELECT = 'SELECT',
  DATE = 'DATE',
}

export type ConfirmDetail = {
  label: string
  value: string
  type?: ConfirmDetailType
  options?: Option[]
  key?: string
}

export enum ConfirmAsideVariant {
  INCLUDED = 'INCLUDED',
  PAID = 'PAID',
}

export type ItemCard = {
  id: string | number
  title: string
  subtitle?: string
  aside?: string
  asideVariant?: ConfirmAsideVariant
  details?: ConfirmDetail[]
  detailsLayout?: ConfirmLayout
}

export enum ConfirmLayout {
  SUMMARY = 'SUMMARY',
  DETAILS = 'DETAILS',
}

export const CONFIRM_SKIP_NAVIGATION = false as const

export const CONFIRM_ABORT = true as const

export type ConfirmResult =
  | void
  | typeof CONFIRM_SKIP_NAVIGATION
  | typeof CONFIRM_ABORT

export type ConfirmSummary = {
  details: ConfirmDetail[]
  total?: ConfirmDetail
}

export type ConfirmData = {
  title?: string
  subtitle?: string
  description?: string
  layout?: ConfirmLayout
  footer?: string
  warning?: string
  summary?: ConfirmSummary
  itemCards?: ItemCard[]
  confirmLabel?: string
  backLabel?: string
  showTermsLink?: boolean
  allowIncompleteProfile?: boolean
  payload?: unknown
  returnTo?: string
  returnState?: unknown
  onConfirm?: (
    remainingItems: ItemCard[],
    selectedValues?: Record<string, string>,
    payload?: unknown
  ) => ConfirmResult | Promise<ConfirmResult>
  onCancel?: () => void
}
